module.exports = "tr {\n  cursor: pointer; }\n\n.nohover {\n  cursor: inherit; }\n\n.contracts {\n  width: 90px;\n  text-align: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/analytics/analytics.component.scss
// module id = ./src/app/main/analytics/analytics.component.scss
// module chunks = main